import React, { useMemo } from 'react';
import NumArrow from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/NumArrow';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import CardRateContent from '../../components/CardRateContent';
import useOverviewCardHooks from '../../useOverviewCardHooks';
import { ratioValueFormat } from '@/pages/home/utils/common';
export type LanguageType = 'origin' | 'en' | 'zh';
export type TipsMapType = {
  [key in LanguageType]?: string | JSX.Element;
} & { space?: number; sort?: Array<LanguageType> };

interface ICardValueContent {
  titleContent: string;
  baseIndicators: any;
  numArrowData: any;
  rankData: any;
  rankLoading?: boolean;
  cardItem?: any;
  metricTitleLocaleText: string;
  dateType?: string;
  isRatioValueFormat?: boolean;
  isRatioValueFormatNoPrecent?: boolean;
  // 是否展示比值 hover 提示浮窗
  isShowRateTips?: boolean;
  // 是否显示 Rank 区域，默认显示
  isShowRank?: boolean;
}

// overview卡片数值区域新组件
const CardValueContent = (props: ICardValueContent) => {
  const {
    titleContent: titleContentTemp,
    baseIndicators,
    numArrowData,
    rankData,
    rankLoading,
    cardItem,
    metricTitleLocaleText,
    dateType,
    isRatioValueFormat = false,
    isRatioValueFormatNoPrecent = false,
    isShowRateTips,
    isShowRank = true,
  } = props;

  const { formatMessage } = useIntlExtend();
  const { titleContentValue: titleContent } = useOverviewCardHooks({
    titleContentTemp,
  });
  const ifShowRank = useMemo(() => isShowRank && titleContentTemp !== 'Rank', [isShowRank, titleContentTemp]);
  return (
    <>
      <div className="context-num-flex">
        {baseIndicators?.indicatorsVal !== null ? (
          <>
            <span className="num-text">
              {/* eslint-disable-next-line no-nested-ternary */}
              {titleContent === 'PHeat'
                ? Math.round(Number(baseIndicators?.indicatorsVal || 0))
                : isRatioValueFormat
                ? ratioValueFormat(
                    baseIndicators?.indicatorsVal,
                    2,
                    false,
                    0,
                    isRatioValueFormatNoPrecent,
                    3,
                  )
                : baseIndicators?.indicatorsVal}
              {/* {isRatioValueFormat ? '%' : ''} */}
            </span>
            {titleContent === 'PHeat' || titleContent === 'RPD' ? null : (
              <CardRateContent
                numArrowData={numArrowData}
                cardItem={cardItem}
                metricTitleLocaleText={metricTitleLocaleText}
                dateType={dateType}
                isShowRateTips={isShowRateTips}
              />
            )}
          </>
        ) : (
          <span className="num-text">--</span>
        )}
      </div>
      {ifShowRank && (
        <div className="rank-flex">
          {/* eslint-disable-next-line no-nested-ternary */}
          {rankLoading ? (
            <span className="rank-flex-desc">{formatMessage({ id: 'dbi_rank_loading' })}</span>
          ) : baseIndicators?.rankVal ? (
            <>
              <span className="rank-flex-num">
                {formatMessage({ id: 'dbi_rank' })} {baseIndicators?.rankVal}
              </span>
              <span className="rank-flex-desc">
                {titleContent === 'PHeat' ? null : (
                  <NumArrow dataContent={rankData ?? {}} type={'rank'}></NumArrow>
                )}
              </span>
            </>
          ) : (
            <span className="rank-flex-desc">{formatMessage({ id: 'dbi_rank' })} -</span>
          )}
        </div>
      )}
    </>
  );
};
export default CardValueContent;
